(function () {
  var cardSelector = '[data-nak-premium-card]';
  var activeCard = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var foilPattern = /\b(reverse\s+holofoil|reverse\s+holo|special\s+illustration\s+rare|illustration\s+rare|ultra\s+rare|secret\s+rare|hyper\s+rare|rainbow\s+rare|amazing\s+rare|trainer\s+gallery|galarian\s+gallery|ace\s+spec|holofoil|holo|foil|gold|shiny|radiant|sir|ex|vmax|vstar|gx)\b/i;

  function clamp(value) {
    return Math.max(0, Math.min(1, value));
  }

  function getCard(target) {
    if (!target || !target.closest) return null;
    return target.closest(cardSelector);
  }

  function getCardFromPoint(event) {
    var direct = getCard(event.target);
    if (direct) return direct;

    if (document.elementsFromPoint) {
      var elements = document.elementsFromPoint(event.clientX, event.clientY);
      for (var i = 0; i < elements.length; i++) {
        var found = getCard(elements[i]);
        if (found) return found;
      }
    }

    var scope =
      event.target.closest &&
      event.target.closest('.card-wrapper, .product-card-wrapper, .grid__item, .card, li');

    if (scope) {
      var scopedCard = scope.querySelector(cardSelector);
      if (scopedCard) return scopedCard;
    }

    var cards = document.querySelectorAll(cardSelector);
    for (var j = 0; j < cards.length; j++) {
      var rect = cards[j].getBoundingClientRect();
      if (
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
      ) {
        return cards[j];
      }
    }

    return null;
  }

  function getFoilText(card) {
    var imageAlts = Array.prototype.map
      .call(card.querySelectorAll('img[alt]'), function (image) {
        return image.getAttribute('alt') || '';
      })
      .join(' ');

    return [
      card.getAttribute('data-title') || '',
      card.getAttribute('data-tags') || '',
      card.getAttribute('data-product-type') || '',
      imageAlts
    ].join(' ');
  }

  function initCard(card) {
    if (!card || card.dataset.nakPremiumInitialized === 'true') return;

    card.dataset.nakPremiumInitialized = 'true';
    card.dataset.nakFoil = foilPattern.test(getFoilText(card)) ? 'true' : 'false';
    resetCard(card);
  }

  function initCards(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(cardSelector), initCard);
  }

  function getProductLink(element) {
    if (!element) return null;
    if (element.matches && element.matches('a[href*="/products/"]')) return element;
    return element.querySelector && element.querySelector('a[href*="/products/"]');
  }

  function hasProductLink(element) {
    return Boolean(getProductLink(element));
  }

  function isExcludedImage(image) {
    if (!image) return false;

    return Boolean(
      image.closest(
        'cart-drawer, cart-notification, .cart, .cart-item, .cart-notification, .cart-drawer, .shopify-policy__container, .article, .collection-hero, .banner, .slideshow, .logo, .header__heading, .footer'
      ) ||
        image.classList.contains('addIcon') ||
        image.classList.contains('mega-menu-image') ||
        image.classList.contains('ratina-img') ||
        image.classList.contains('icon') ||
        (image.getAttribute('src') || '').indexOf('.svg') > -1
    );
  }

  function isExcludedContainer(container) {
    if (!container) return true;

    return Boolean(
      container.closest(
        'cart-drawer, cart-notification, .cart, .cart-item, .cart-notification, .cart-drawer, .shopify-policy__container, .article, .collection-hero, .banner, .slideshow, .logo, .header__heading, .footer'
      )
    );
  }

  function hasBackgroundImage(element) {
    if (!element || element.nodeType !== 1) return false;

    var inlineBackground = element.style && element.style.backgroundImage;
    var computedBackground = '';

    if (window.getComputedStyle) {
      computedBackground = window.getComputedStyle(element).backgroundImage;
    }

    return Boolean(
      (inlineBackground && inlineBackground !== 'none') ||
        (computedBackground && computedBackground !== 'none')
    );
  }

  function hasMediaContent(element) {
    return Boolean(
      element &&
        element.querySelector &&
        (element.querySelector('img') ||
          element.querySelector('picture') ||
          element.querySelector('source') ||
          hasBackgroundImage(element))
    );
  }

  function getProductTitle(container, image) {
    var link = container.querySelector && container.querySelector('a[href*="/products/"]');
    var titleNode =
      container.querySelector &&
      container.querySelector(
        '.card__heading, .card-information__text, .grid-view-item__title, .product-card__title, .predictive-search__item-heading, .ruby-list-heading, [aria-label], [title]'
      );

    return (
      (titleNode && (titleNode.getAttribute('aria-label') || titleNode.getAttribute('title') || titleNode.textContent || '').trim()) ||
      (link && (link.getAttribute('aria-label') || link.getAttribute('title') || '').trim()) ||
      (image && image.getAttribute && (image.getAttribute('alt') || '').trim()) ||
      ''
    );
  }

  function ensureOverlay(card, className) {
    if (card.querySelector('.' + className)) return;

    var overlay = document.createElement('span');
    overlay.className = className;
    overlay.setAttribute('aria-hidden', 'true');
    card.appendChild(overlay);
  }

  function chooseVisibleProductImageFrame(container) {
    if (!container) return null;

    if (container.closest('.card__media')) return container.closest('.card__media');

    if (
      container.matches &&
      container.matches('.product-grid-item__image, .grid_set_box, .predictive-search__image, .mega-menu-product-image')
    ) {
      return container;
    }

    return (
      container.closest('.card-wrapper') ||
      container.closest('.product-card-wrapper') ||
      container.closest('.grid__item') ||
      container
    );
  }

  function demoteNestedPremiumCards(target) {
    Array.prototype.forEach.call(target.querySelectorAll(cardSelector), function (nestedCard) {
      if (nestedCard === target) return;

      nestedCard.classList.remove('nak-premium-card');
      nestedCard.removeAttribute('data-nak-premium-card');
      nestedCard.removeAttribute('data-nak-premium-initialized');
      nestedCard.removeAttribute('data-nak-active');
      nestedCard.removeAttribute('data-nak-foil');
      nestedCard.style.removeProperty('--mx');
      nestedCard.style.removeProperty('--my');
      nestedCard.style.removeProperty('--rx');
      nestedCard.style.removeProperty('--ry');
      nestedCard.style.removeProperty('--scale');

      Array.prototype.forEach.call(
        nestedCard.querySelectorAll('.nak-card-shine, .nak-card-foil, .nak-card-edge'),
        function (overlay) {
          if (overlay.parentNode === nestedCard) overlay.parentNode.removeChild(overlay);
        }
      );
    });
  }

  function enhanceContainer(container, sourceImage) {
    var target = chooseVisibleProductImageFrame(container);
    if (!target) return;
    if (target.dataset.nakPremiumCard !== undefined) {
      initCard(target);
      return;
    }
    if (isExcludedContainer(target) || isExcludedImage(sourceImage)) return;
    if (!sourceImage && !hasMediaContent(container) && !hasMediaContent(target)) return;

    var productScope = target.closest(
      '.card-wrapper, .product-card-wrapper, .grid__item, .product-grid, .collection, predictive-search, .predictive-search__list-item, .newgrid, .product-column, .recently-viewed-products'
    );
    var productLink = target.matches('a[href*="/products/"]')
      ? target
      : target.querySelector && target.querySelector('a[href*="/products/"]');

    if (!productLink && productScope) {
      productLink = productScope.querySelector('a[href*="/products/"]');
    }

    if (!productLink) return;

    demoteNestedPremiumCards(target);

    target.classList.add('nak-premium-card');
    target.setAttribute('data-nak-premium-card', '');
    target.setAttribute('data-title', getProductTitle(productScope || target, sourceImage));
    target.setAttribute('data-tags', '');
    target.setAttribute('data-product-type', '');

    ensureOverlay(target, 'nak-card-shine');
    ensureOverlay(target, 'nak-card-foil');
    ensureOverlay(target, 'nak-card-edge');
    initCard(target);
  }

  function enhanceMissedProductGridImages(root) {
    var scope = root || document;
    var candidateSelector = [
      '.card-wrapper .card__media .media',
      '.card-wrapper .card__media',
      '.product-card-wrapper .card__media .media',
      '.product-card-wrapper .card__media',
      '.grid__item .card__media .media',
      '.grid__item .card__media',
      '.product-grid .card__media .media',
      '.product-grid .card__media',
      '.collection .card__media .media',
      '.collection .card__media'
    ].join(',');

    Array.prototype.forEach.call(scope.querySelectorAll(candidateSelector), function (container) {
      var image = container.querySelector('img');
      if (!image && !hasMediaContent(container)) return;
      if (!hasProductLink(container) && !hasProductLink(container.closest('.card-wrapper, .product-card-wrapper, .grid__item, .product-grid, .collection'))) return;
      enhanceContainer(container, image);
    });

    Array.prototype.forEach.call(
      scope.querySelectorAll(
        '.card-wrapper, .product-card-wrapper, .grid__item, .product-grid .grid__item, .collection .grid__item, .newgrid, .product-column, .recently-viewed-products .grid__item'
      ),
      function (productScope) {
        if (!hasProductLink(productScope)) return;

        var container =
          productScope.querySelector('.card__media .media') ||
          productScope.querySelector('.card__media') ||
          productScope.querySelector('.product-grid-item__image') ||
          productScope.querySelector('.grid_set_box') ||
          productScope.querySelector('.predictive-search__image') ||
          productScope.querySelector('.mega-menu-product-image') ||
          productScope.querySelector('[style*="background-image"]') ||
          productScope.querySelector('picture') ||
          productScope.querySelector('img') ||
          productScope.querySelector('a[href*="/products/"]');

        var image = container && container.querySelector ? container.querySelector('img') : null;
        if (container && (image || hasMediaContent(container) || hasBackgroundImage(container))) {
          enhanceContainer(container, image);
        }
      }
    );

    Array.prototype.forEach.call(scope.querySelectorAll('a[href*="/products/"] img'), function (image) {
      if (isExcludedImage(image)) return;

      var container =
        image.closest('.card__media .media, .card__media, .product-grid-item__image, .grid_set_box, .predictive-search__image, .mega-menu-product-image') ||
        (image.parentElement && image.parentElement.tagName !== 'A' ? image.parentElement : null) ||
        image.closest('a[href*="/products/"]');

      enhanceContainer(container, image);
    });
  }

  function resetCard(card) {
    if (!card) return;

    card.style.setProperty('--mx', '50%');
    card.style.setProperty('--my', '50%');
    card.style.setProperty('--rx', '0deg');
    card.style.setProperty('--ry', '0deg');
    card.style.setProperty('--scale', '1');
    card.dataset.nakActive = 'false';
  }

  function handlePointerMove(event) {
    if (reduceMotion || !finePointer) return;

    var card = getCardFromPoint(event);
    if (!card) return;

    if (activeCard && activeCard !== card) resetCard(activeCard);
    activeCard = card;
    card.dataset.nakActive = 'true';

    var rect = card.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var x = clamp((event.clientX - rect.left) / rect.width);
    var y = clamp((event.clientY - rect.top) / rect.height);
    var rotateY = (x - 0.5) * 26;
    var rotateX = (0.5 - y) * 30;

    card.style.setProperty('--mx', x * 100 + '%');
    card.style.setProperty('--my', y * 100 + '%');
    card.style.setProperty('--rx', rotateX.toFixed(2) + 'deg');
    card.style.setProperty('--ry', rotateY.toFixed(2) + 'deg');
    card.style.setProperty('--scale', '1.04');
  }

  function handlePointerOut(event) {
    if (!activeCard) return;

    var nextTarget = event.relatedTarget;
    if (nextTarget && activeCard.contains(nextTarget)) return;

    resetCard(activeCard);
    activeCard = null;
  }

  function bindEvents() {
    enhanceMissedProductGridImages(document);
    initCards(document);

    document.addEventListener('shopify:section:load', function (event) {
      enhanceMissedProductGridImages(event.target);
      initCards(event.target);
    });

    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType !== 1) return;
            if (node.querySelectorAll) enhanceMissedProductGridImages(node);
            if (node.matches && node.matches(cardSelector)) initCard(node);
            if (node.querySelectorAll) initCards(node);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (reduceMotion || !finePointer) return;

    document.addEventListener('pointermove', handlePointerMove, { passive: true });
    document.addEventListener('pointerout', handlePointerOut, { passive: true });
    window.addEventListener('blur', function () {
      resetCard(activeCard);
      activeCard = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEvents);
  } else {
    bindEvents();
  }
})();
